import React from "react"
import { Route, route } from "react-router-dom"
import Manual from "./Manual"
import Automacao from "./Automacao"
import Processando from "./Processando"
import Dashboard from "./Painel"

// export default [
//   <Route
//     path="/captura/manual"
//     exact
//     component={(props) => <Manual {...props} />}
//   />,
//   <Route
//     path="/captura/automacao"
//     exact
//     component={(props) => <Automacao {...props} />}
//   />,
// ]

export default [
  {
    path: "/captura/manual",
    component: Manual,
  },
  {
    path: "/captura/automacao",
    component: Automacao,
  },
  {
    path: "/captura/processando",
    component: Processando,
  },
  {
    path: "/jobs/executados",
    component: Processando,
  },
  {
    path: "/jobs/dashboard/:id",
    component: Dashboard,
  },
]
